import { render, staticRenderFns } from "./dialogEditZhuyuan.vue?vue&type=template&id=331dd20e&scoped=true&"
import script from "./dialogEditZhuyuan.vue?vue&type=script&lang=js&"
export * from "./dialogEditZhuyuan.vue?vue&type=script&lang=js&"
import style0 from "./dialogEditZhuyuan.vue?vue&type=style&index=0&id=331dd20e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331dd20e",
  null
  
)

export default component.exports